import type { ItemStatus } from '@/lib/api/types/itemStatus';
import type { Item } from '@/lib/api/types/items';
import type { ItemType, ItemTypeLevel } from '@/lib/api/types/itemType';

/** These constants are used to provide default STABLE empty arrays for item types, levels, statuses, and IDs.
 * This helps to avoid unnecessary re-renders in components/hooks that depend on these arrays,
 * as they will reference the same stable empty array instance instead of creating a new one on each render.
 * The EMPTY_STATUS_MAP is used to provide a default stable empty map for item statuses, ensuring that components
 * can safely access it without needing to check for undefined values. */
export const EMPTY_ITEMS: Item[] = [];
export const EMPTY_ITEM_TYPES: ItemType[] = [];
export const EMPTY_ITEM_LEVELS: ItemTypeLevel[] = [];
export const EMPTY_ITEM_STATUSES: ItemStatus[] = [];
export const EMPTY_ITEM_IDS: number[] = [];
export const EMPTY_STATUS_MAP: Map<number, ItemStatus> = new Map();
